import React, { useState, useEffect } from 'react';
import ConsumerSearchComponent from './consumer-search-component';
import ConsumerTabsComponent from './consumer-tabs-component'; 
import { useConsumerApi } from '../../../../hooks/useConsumerApi';

const ConsumerMainComponent = () => {
  const [selectedConsumer, setSelectedConsumer] = useState(null); 
  const [consumerId, setConsumerId] = useState(null);
  const { getConsumerById } = useConsumerApi(); 

  const handleViewClick = (consumer) => {
    setConsumerId(consumer.id); // trigger fetch via useEffect
  };

  useEffect(() => {
    const fetchConsumer = async () => {
      if (consumerId) {
        const data = await getConsumerById(consumerId);
        if (data) {
          console.log('Fetched consumer data:', data);
          setSelectedConsumer(data.data); 
        }
      }
    };

    fetchConsumer();
  }, [consumerId, getConsumerById]);

  const handleBackToSearch = () => {
    setSelectedConsumer(null);
    setConsumerId(null);
  };

  return (
    <div>
      {!selectedConsumer ? (
        <ConsumerSearchComponent onViewClick={handleViewClick} />
      ) : (
        <ConsumerTabsComponent
          consumer={selectedConsumer}
          onBack={handleBackToSearch}
        />
      )}
    </div>
  );
};

export default ConsumerMainComponent;
